import { FunctionalComponent, h } from "preact";
import { useTranslation } from "react-i18next";
import Four04Icon from "../../assets/icons/404.svg";

const Four04: FunctionalComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="flex flex-col items-center">
          <img className="w-52" src={Four04Icon} alt="" />

          <h1 className="mt-2 text-lg font-medium text-gray-900 tracking-tight">
            {t("404.message")}.
          </h1>
        </main>
      </div>
    </div>
  );
};

export default Four04;
